/******/ (() => { // webpackBootstrap
  var __webpack_exports__ = {};
  window.PXUTheme.jsThumbnailsCarousel = {
    init: function($section, index) {
      
      this.element = $section[0];

      // Add settings from schema to current object
      window.PXUTheme.jsThumbnailsCarousel = $.extend(this, window.PXUTheme.getSectionData($section));

      this.delegateElement = new domDelegate.Delegate(this.element);
      this.prevButton = this.element.querySelector("[data-carousel='previous']");
      this.nextButton = this.element.querySelector("[data-carousel='next']");

      let $this = this;
      // Selectors
      this.carouselElement = this.element.querySelector('.swiper');
      
      this.carousel = new Swiper(this.carouselElement, {
        grabCursor: true,
        slidesPerView: 2.30,
        spaceBetween: 16,
        loopAdditionalSlides: 3,
        slidesOffsetAfter: 24,
        navigation: {
          nextEl: this.nextButton,
          prevEl: this.prevButton,
        },
        breakpoints: {
          799: {
            slidesPerView: 4,
            slidesOffsetAfter: 0,
          }
        }
      });

    },
    unload: function($section) {
  
    }
  }  
/******/ })();